var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"dense":"","outlined":"","type":"error"}},[_vm._v(" Acceso Denegado - El usuario no tiene los permisos suficientes. ")])}
var staticRenderFns = []

export { render, staticRenderFns }